module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/cross-3d003acd243d7da5c09b94e12c38a5b1.svg";